'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getCurrentColumnResizeHandleInfo, getShouldShowGridAndToolbars } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import LayoutSectionResizeHandle from 'InpageEditorUI/components/LayoutSectionResizeHandle';
import { resizeHandleTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  columnResizeHandleInfo: getCurrentColumnResizeHandleInfo(state),
  shouldShowGridAndToolbars: getShouldShowGridAndToolbars(state),
  isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state)
});
class LayoutSectionResizeHandleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false
    };
  }
  renderResizeHandle({
    type,
    handleTop = 0,
    handleLeft = 0,
    handleHeight = 0,
    gutterTop = 0,
    gutterLeft = 0,
    gutterHeight = 0,
    gutterWidth = 0,
    missing = false,
    leftColumn = {},
    rightColumn = {}
  }) {
    const {
      isInDefaultBreakpointMode
    } = this.props;
    if (isInDefaultBreakpointMode) {
      return /*#__PURE__*/_jsx(LayoutSectionResizeHandle, {
        type: type,
        handleTop: handleTop,
        handleLeft: handleLeft,
        handleHeight: handleHeight,
        gutterTop: gutterTop,
        gutterLeft: gutterLeft,
        gutterHeight: gutterHeight,
        gutterWidth: gutterWidth,
        shouldHide: missing,
        leftColumn: leftColumn,
        rightColumn: rightColumn,
        setDragging: val => this.setState({
          dragging: val
        })
      });
    }
    return null;
  }
  render() {
    const {
      columnResizeHandleInfo,
      shouldShowGridAndToolbars
    } = this.props;
    const {
      dragging
    } = this.state;

    // Break the resize info from an array into separate variables, to help prevent unnecessary
    // unmounting/reconciliation (for perf)
    let leftResizeHandleInfo = {
      missing: true,
      type: resizeHandleTypes.RESIZE_HANDLE_LEFT
    };
    let rightResizeHandleInfo = {
      missing: true,
      type: resizeHandleTypes.RESIZE_HANDLE_RIGHT
    };
    for (const resizeHandleInfo of columnResizeHandleInfo) {
      if (resizeHandleInfo.type === resizeHandleTypes.RESIZE_HANDLE_LEFT) {
        leftResizeHandleInfo = resizeHandleInfo;
      } else if (resizeHandleInfo.type === resizeHandleTypes.RESIZE_HANDLE_RIGHT) {
        rightResizeHandleInfo = resizeHandleInfo;
      }
    }
    const classes = classNames('hs-ls-resize-handle-container', !shouldShowGridAndToolbars && 'hs-hide', dragging && 'dragging');
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [!leftResizeHandleInfo.missing && this.renderResizeHandle(leftResizeHandleInfo), !rightResizeHandleInfo.missing && this.renderResizeHandle(rightResizeHandleInfo)]
    });
  }
}
LayoutSectionResizeHandleContainer.propTypes = {
  columnResizeHandleInfo: PropTypes.array.isRequired,
  shouldShowGridAndToolbars: PropTypes.bool.isRequired,
  isInDefaultBreakpointMode: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(LayoutSectionResizeHandleContainer);